import { axiosPlatform } from "../../../../_services/axios-helper";

export const amazonpayService = {
    getAllAmazonPayConfigurations,
    addAmazonPayConfiguration,
    deleteAmazonPayConfiguration,
    updateAmazonPayConfiguration,
    uploadAmazonPayDataFile,
    migrateToVersion2,
};

function getAllAmazonPayConfigurations() {
    return axiosPlatform().get("/integrations/amazonpay");
}

function addAmazonPayConfiguration(configuration) {
    return axiosPlatform().post("/integrations/amazonpay", configuration);
}

function deleteAmazonPayConfiguration(configurationUUID) {
    return axiosPlatform().delete("/integrations/amazonpay/" + configurationUUID);
}

function updateAmazonPayConfiguration(configuration) {
    return axiosPlatform().put("/integrations/amazonpay/update", configuration);
}

function uploadAmazonPayDataFile(data, importId) {
    return axiosPlatform().post("/integrations/amazonpay/import/" + importId, data);
}

function migrateToVersion2(configuration) {
    return axiosPlatform().post("/integrations/amazonpay/migrate", configuration);
}
